import type { ReactNode } from 'react';

import {
  hasAnyPermission,
  hasPermission,
  useCurrentMembership,
  type PermissionCode,
} from '@/lib/permissions';

interface PermissionGateProps {
  children: ReactNode;
  permission?: PermissionCode | string;
  anyPermission?: readonly (PermissionCode | string)[];
  fallback?: ReactNode;
}

/** Renders children only when the signed-in user holds the required permission. */
export const PermissionGate = ({
  children,
  permission,
  anyPermission,
  fallback = null,
}: PermissionGateProps) => {
  const membership = useCurrentMembership();

  if (!permission && !anyPermission) {
    if (import.meta.env.DEV) {
      throw new Error('PermissionGate requires permission or anyPermission');
    }
    return fallback;
  }

  const allowed = permission
    ? hasPermission(membership, permission)
    : hasAnyPermission(membership, anyPermission ?? []);

  return allowed ? children : fallback;
};
